var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayEclipse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 86",
    d: "M153.833 77.25C153.833 119.5 119.583 153.75 77.333 153.75C35.0832 153.75 0.833008 119.5 0.833008 77.25C0.833008 35.0002 35.0832 0.75 77.333 0.75C119.583 0.75 153.833 35.0002 153.833 77.25ZM16.133 77.25C16.133 111.05 43.5332 138.45 77.333 138.45C111.133 138.45 138.533 111.05 138.533 77.25C138.533 43.4502 111.133 16.05 77.333 16.05C43.5332 16.05 16.133 43.4502 16.133 77.25Z",
    fill: "#A8AEE8",
    fillOpacity: 0.14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayEclipse);
export default __webpack_public_path__ + "static/media/GrayEclipse.7a642983ba0849d44d7d13e8e6205448.svg";
export { ForwardRef as ReactComponent };